/* eslint-disable import/no-anonymous-default-export */

import Profile1 from "../assets/images/profile-picture-1.jpg"

const notifications = [
    {
        "id": 1,
        "read": false,
        "image": Profile1,
        "sender": "Test user",
        "time": "a few moments ago",
        "link": "#",
        "message": `Test Message`
    }
]

export default notifications